const KDDMenu = [
    {id: "0", value: "日D"},    
    {id: "1", value: "週D"},
    {id: "2", value: "月D"}    
  ];  
  
  export default KDDMenu